var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tender-container-wrapper" }, [
    _c("div", { staticClass: "tender-container clearfix" }, [
      _c(
        "h4",
        [
          _c("HKLLeftRight", {
            scopedSlots: _vm._u(
              [
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("tender.dashboardTableTitle"))),
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-refresh dark flat icon_refresh",
                        on: {
                          click: function ($event) {
                            return _vm.loadTenderTable()
                          },
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                _vm.isHKlandUser
                  ? {
                      key: "right",
                      fn: function () {
                        return [
                          _c("HKLButton", {
                            staticClass: "btn-reset",
                            attrs: { action: "resetFilter", color: "darkblue" },
                            on: {
                              click: function () {
                                return _vm.resetFilterObject()
                              },
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tender-table" }, [
        _c("table", { staticClass: "hover" }, [
          _c("thead", [
            _c(
              "tr",
              _vm._l(_vm.itemHeaders, function (header) {
                return _c(
                  "th",
                  {
                    key: header.code,
                    class: header.class,
                    on: {
                      click: function ($event) {
                        return _vm.sortBy(header.code)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(header.name()) +
                        " " +
                        _vm._s(
                          _vm.orderbyAttr === header.code
                            ? _vm.reverse
                              ? "▼"
                              : "▲"
                            : null
                        ) +
                        "\n            "
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.isHKlandUser
              ? _c(
                  "tr",
                  _vm._l(_vm.itemHeaders, function (header) {
                    return _c(
                      "th",
                      { key: header.code },
                      [
                        _c(
                          header.filterComponent,
                          _vm._b(
                            {
                              tag: "component",
                              model: {
                                value: _vm.filterObject[header.code],
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterObject, header.code, $$v)
                                },
                                expression: "filterObject[header.code]",
                              },
                            },
                            "component",
                            header.filterComponentAttrs || {},
                            false
                          )
                        ),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.orderedItems, function (item) {
              return _c("tr", { key: item.id }, [
                _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "link_text",
                      class: { "no-finger": _vm.disableLink(item) },
                      attrs: {
                        disabled: _vm.disableLink(item),
                        title: item.rejectReason,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.navToPage(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.prNumber) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      staticClass: "link_text",
                      class: { "no-finger": _vm.disableLink(item) },
                      attrs: {
                        disabled: _vm.disableLink(item),
                        title: item.rejectReason,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.navToPage(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.prDescription) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(item.site))]),
                _vm._v(" "),
                _c("td", { staticClass: "number_text" }, [
                  item.showQIndicator ? _c("span", [_vm._v("(Q) ")]) : _vm._e(),
                  _vm._v(_vm._s(item.statusText) + "\n            "),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "number_text" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.dateUtil.formatDate(item.updateDate, true, true)
                      ) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    class: {
                      number_text: true,
                      "closing-date-red": item.isRepresentative,
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (item.closingDate &&
                            _vm.dateUtil.formatDate(
                              item.closingDate,
                              true,
                              true
                            )) ||
                            "--"
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("td", { staticClass: "number_text" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        item.budget
                          ? _vm.currencyFormatter.format(
                              item.budget || 0,
                              "USD"
                            )
                          : "--"
                      ) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "number_text" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(item.currencyCode) +
                      "\n            "
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nav_line" },
        [
          _vm.showCreateButton()
            ? _c("ConfirmCreate", { staticClass: "nav_button" })
            : _vm._e(),
          _vm._v(" "),
          _vm.showViewAllButton()
            ? _c(
                "button",
                {
                  staticClass: "nav_button btn btn--darkblue",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.navToAllTenders()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("action.viewAllTenders")) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }